import { useMemo } from 'react';
const useGTM = () => {
  const dataLayer = useMemo(() => window?._mtm || [], []);
  return { dataLayer };
};

export default useGTM;
